/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import PropTypes from 'prop-types';
import useCachedAssetSrc from '../hooks/useCachedAssetSrc';

/**
 * Thin <img>/<video> wrapper for simple call sites with no bespoke
 * loading/error state of their own (e.g. the brand logo). Falls back to a
 * locally cached blob on load failure — see useCachedAssetSrc.
 */
const CachedImage = ({ token, src, as: Tag = 'img', onFallbackFailed, ...rest }) => {
  const { src: resolvedSrc, tryFallback } = useCachedAssetSrc(token, src);

  const handleError = async (event) => {
    const usedFallback = await tryFallback();
    if (!usedFallback) onFallbackFailed?.(event);
  };

  return <Tag src={resolvedSrc} onError={handleError} {...rest} />;
};

CachedImage.propTypes = {
  token: PropTypes.string,
  src: PropTypes.string,
  as: PropTypes.oneOf(['img', 'video']),
  onFallbackFailed: PropTypes.func,
};

export default CachedImage;
